import {Ng1Controller, Transition, TargetState, StateService} from "@uirouter/angularjs";
import {DataHubService} from "../../modules/DataHubModule";
import {IHttpService, IScope} from "angular";
import {SpinnerService} from "../../modules/SpinnerModule";
import {ConfigService} from "../../modules/ConfigModule";
import {ngStorage} from "ngstorage";
import StorageService = ngStorage.StorageService;
import {MerchantResidualImportDto} from "../../model/MerchantResidualImportDto";

export default class MerchantResidualController implements Ng1Controller {
    private error: any;
    private model: MerchantResidualImportDto;
    private fileInput: HTMLInputElement;

    $onInit(): void {
        this.refresh();
    }

    uiCanExit(transition: Transition): boolean | TargetState | void | Promise<boolean | TargetState | void> {
        return undefined;
    }

    uiOnParamsChanged(newValues: any, $transition$: Transition): void {
    }

    constructor(private $dataHub: DataHubService,
                private $scope: IScope,
                private $http: IHttpService,
                private $spinner: SpinnerService,
                private $sessionStorage: StorageService,
                private $config: ConfigService,
                private $state: StateService,
                private $stateParams: any) {
        $dataHub.onConnected(this.refresh);

        this.model = $sessionStorage.merchantResidualImport;
        if (!this.model) {
            this.reset();
        }
        
        $scope.$watch(() => this.model ? this.model.merchantResidualType : null, newValue => {
            this.reset();
        })
    }

    reset = () => {
        var type = this.model ? this.model.merchantResidualType || 1 : 1;
        this.$http.get<MerchantResidualImportDto>(this.$config.apiBase + 'import/merchantResidual/prepare/' + type)
            .then(r => {
                this.$sessionStorage.merchantResidualImport = r.data;
                this.model = this.$sessionStorage.merchantResidualImport;
            })
            .catch(this.$dataHub.defaultErrorHandler);
        if (this.fileInput)
            this.fileInput[0].value = "";
    };

    refresh = () => {
        if (!this.$dataHub.isConnected) return;
        // load data or something
    };

    fileSelect = () => {
        var input = this.fileInput[0];
        input.value = null;
        input.onchange = this.fileInputChanged;
        input.click();
    };

    fileInputChanged = () => {
        const file = this.fileInput[0].files[0];

        const reader = new FileReader();
        reader.onload = () => {
            this.$scope.$apply(() => {
                this.model.fileName = file.name;
                this.model.fileData = reader.result.toString();
                this.prepare();
            });
        };
        reader.readAsDataURL(file);

    };

    prepare = () => {
        this.$spinner.show('Preparing');
        this.$http.post<MerchantResidualImportDto>(this.$config.apiBase + 'import/merchantResidual/prepare', this.model)
            .then(r => {
                this.$sessionStorage.merchantResidualImport = r.data;
                this.model = this.$sessionStorage.merchantResidualImport;
            })
            .catch(this.$dataHub.defaultErrorHandler)
            .finally(() => this.$spinner.hide());
    };

    import = () => {
        this.$spinner.show('Importing');
        this.$http.post<MerchantResidualImportDto>(this.$config.apiBase + 'import/merchantResidual/process', this.model)
            .then(r => {
                this.reset();
            })
            .catch(this.$dataHub.defaultErrorHandler)
            .finally(() => this.$spinner.hide());
    }
}
